import React, { useMemo } from 'react';
import CreateClientDialog from './CreateClientDialog';
import ClientNotesPanel from './ClientNotesPanel';
import { getInitialEditClientDialogModel } from './editClientDialog.helpers';

export default function EditClientDialog({ client, onSave, staff = [], ...props }) {
  const initialValue = useMemo(() => getInitialEditClientDialogModel(client), [client]);
  if (!client) return null;
  return <CreateClientDialog key={client.id} {...props} editing emptyClient={initialValue} staff={staff}
    onCreate={onSave} comments={<ClientNotesPanel clientId={client.id} open={props.open} staff={staff} />} />;
}
